import Cookies from 'universal-cookie'

export const cookieValueForProject = (id: string) => {
  const cookies = new Cookies()
  const clientHeaderCookie = cookies.get('client-header')
  if (!clientHeaderCookie) return

  return (clientHeaderCookie as Record<string, string>)[id] as string
}

export const hasWirWunderCookie = (projectId: string | number): boolean => {
  const cookieValue = cookieValueForProject(String(projectId))
  return cookieValue?.startsWith('ww-') ?? false
}

export const transformToWirwunderHost = (shareUrl: string): string => {
  const url = new URL(shareUrl)
  const pathWithoutLocale = url.pathname.replace(/^\/[a-z]{2}\//, '/')

  return `https://wirwunder.de${pathWithoutLocale}?${url.searchParams.toString()}`
}
